/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

export interface PremiumCourse {
  id: string;
  title: string;
  image?: string;
  cardImage?: string;
  heroImage?: string;
  description?: string;
  class: string;
}

export const PREMIUM_COURSES: PremiumCourse[] = [
  { 
    id: '6-sci', 
    title: 'NCERT Class 6 Science',
    image: '/images/courses/c6s1.webp',
    description: 'Discover Science through Curiosity, Concept Learning and Smart Practice.',
    class: 'Class 6'
  },
  { 
    id: '6-math', 
    title: 'NCERT Class 6 Mathematics',
    image: '/images/courses/c6m1.webp',
    description: 'Build Strong Mathematical Concepts through Interactive Learning, Smart Practice and Exam-Oriented Assessment.',
    class: 'Class 6'
  },
  { 
    id: '6-social', 
    title: 'NCERT Class 6 Social Science',
    image: '/images/courses/c6ss1.webp',
    description: 'Explore History, Geography, Civics and Economics through interactive learning and smart assessments.',
    class: 'Class 6'
  },
  { 
    id: '7-sci', 
    title: 'NCERT Class 7 Science', 
    image: '/images/courses/c7s1.webp',
    cardImage: '/images/courses/c7s1.webp',
    heroImage: '/images/courses/c7s1.webp',
    description: 'A journey of discovery begins here! From tiny atoms to vast space, from life processes to electricity and motion -Class 7 Science brings the wonders of nature closer to us.',
    class: 'Class 7'
  },
  { 
    id: '7-math', 
    title: 'NCERT Class 7 Mathematics',
    image: '/images/courses/c7m1.webp',
    cardImage: '/images/courses/c7m1.webp',
    heroImage: '/images/courses/c7m1.webp',
    description: 'Develop Logical Thinking, Strong Mathematical Concepts and Problem-Solving Skills through Smart Learning.',
    class: 'Class 7'
  },
  { 
    id: '7-social', 
    title: 'NCERT Class 7 Social Science',
    image: '/images/courses/c7ss1.webp',
    cardImage: '/images/courses/c7ss1.webp',
    heroImage: '/images/courses/c7ss1.webp',
    description: "Understand India's Geography, History, Culture, Constitution and Economy through interactive learning and exam-oriented practice.",
    class: 'Class 7'
  },
  { 
    id: '8-sci', 
    title: 'NCERT Class 8 Science',
    image: '/images/courses/c8s1.webp',
    description: 'Embark on an intensive scientific exploration! Master cell biology, electricity, forces, light optics, ecosystems, and chemical properties with the Class 8 Science Complete Suite.',
    class: 'Class 8'
  },
  { 
    id: '8-math', 
    title: 'NCERT Class 8 Mathematics',
    image: '/images/courses/c8m1.webp',
    description: 'Develop algebraic thinking, geometry, visualization, data handling and problem-solving skills with Class 8 Math Complete Pack.',
    class: 'Class 8'
  },
  { 
    id: '8-social', 
    title: 'NCERT Class 8 Social Science',
    image: '/images/courses/c8ss1.webp',
    description: 'Explore modern Indian history, resource geography, social & political life and key constitution concepts for Class 8.',
    class: 'Class 8'
  },
  { 
    id: '9-sci', 
    title: 'NCERT Class 9 Science',
    image: '/images/courses/c8s1.webp',
    description: 'Explore secondary science foundation! Master cellular biology, motion physics, atomic structure, forces, waves, and Earth systems for Class 9.',
    class: 'Class 9'
  }
];
